import {getData, postData} from './redux_data';
import {
    GET_TIPOS_ZONA,
    MODIFY_TIPO_ZONA,
    ADD_TIPO_ZONA,
    DELETE_TIPO_ZONA,
    UPDATE_TIPOS_ZONA,
} from '../constants/action_types';

export function getTiposZona() {
    return getData('CvTipoZonas', GET_TIPOS_ZONA);
}

export function modifyTipoZona(tipoZona) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_TIPO_ZONA, payload: tipoZona });
    }
}

export function addTipoZona(tipoZona) {
    return (dispatch, getState) => {
        dispatch({ type: ADD_TIPO_ZONA, payload: tipoZona });
    }
}

export function removeTipoZona(tipoZona) {
    return (dispatch, getState) => {
        dispatch({ type: DELETE_TIPO_ZONA, payload: tipoZona });
    }
}

export function updateTiposZonaDB (tiposZona) {
    // return (dispatch, getState) => {
    //     dispatch({ type: UPDATE_TIPOS_ZONA, payload: tiposZona })
    //     let token = getState().oidc.user ? getState().oidc.user.access_token : "";
    //     axios.post(config.API_URI() + 'cvtipozonas/zonas', tiposZona,
    //         {
    //             headers: {
    //                 Authorization: "Bearer " + token
    //             }
    //         }
    //     ).then((response) => {
    //         dispatch({ type: UPDATE_TIPOS_ZONA + "_SUCCESS", payload: response })
    //         dispatch({
    //             type: OPEN_DIALOG,
    //             modalType: 'SimpleMessage',
    //             modalProps: { message: 'Cambios guardados!' },
    //             dialogid: 'success_update_tipo_zona'
    //             });
    //     }).catch((error) => {
    //         dispatch({
    //             type: OPEN_DIALOG,
    //             modalType: 'SimpleMessage',
    //             modalProps: { message: error.response.data.message, exception: error.response.data.ex },
    //             dialogid: 'error_update_tipo_zona'
    //         });
    //     });
    // }

    return postData('cvtipozonas/zonas', UPDATE_TIPOS_ZONA, tiposZona, 'Tipos de zona actualizados', undefined);
}

